import isElement from './isElement';
export default function isSVGElement(node) {
  return isElement(node) && (node instanceof SVGElement || 'ownerSVGElement' in node);
}
//# sourceMappingURL=isSVGElement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/isSVGElement.js
// module id = 221
// module chunks = 0 1